export default __webpack_public_path__ + "static/gs-5-businessvalue-925c525d3cd579585e54ee285d5d585f.jpg";